import api from "./apiClient"; 

export const getPartitionCompanies = async () => {
  const response = await api.post("/DS/admin_center/get_partition_companies.zjs");
  return response.data;
};

export const manageCompany = async ({
  action,
  company_id = "",
  company_name = "",
  company_abbriviation = "",
  lt_country_id = "",
}) => {
  const payload = {
    action,
    company_id,
    company_name,
    company_abbriviation,
    lt_country_id,
  };

  const response = await api.post(
    "/DS/admin_center/partition_company_manager.zjs",
    payload
  );

  return response.data;
};
